@if (ausschreibung !== undefined) {
  <stzh-cspace>
    <stzh-heading level="1" id="anchorContent">Ausschreibung {{ausschreibung.objekt}}</stzh-heading>
    <div class="parsys_column two_cols">
    <div class="parsys_column two_cols-c0">
      <p [innerHTML]="ausschreibung.title"></p>
      @if (!isFreihaendig(ausschreibung.verfahrensartSTADTZH)) {
        <p>Frist: {{ausschreibung.einreichefrist | date : 'dd.MM.yyyy, H:mm'}} Uhr</p>
      }
      @if (!hasAngebot() && inFrist) {
        <a class="mod_button" (click)="createAngebot()"><span class="label">Angebot erstellen</span></a>
      }
      @if (!hasAngebot() && !inFrist) {
        <a class="mod_button button-grey" type="button"><span class="label">Ausschreibung beendet</span></a>
      }
      @if (hasAngebot()) {
        <a class="mod_button" (click)="toAngebot()"><span class="label">Mein Angebot</span></a>
      }
    </div>
    <div class="parsys_column two_cols-c1">
      <stzh-cspace>
        <stzh-heading level="2">Aktueller Stand des Angebots</stzh-heading>
        @if (hasAngebot()) {
          @if (isInBearbeitung(ausschreibung.angebot?.status) && inFrist) {
            <span class="phase active-phase">In Bearbeitung</span>
          }
          @if (isBeendet(ausschreibung.angebot?.status) && inFrist) {
            <span class="phase active-phase">Abgesendet</span>
          }
          @if (!inFrist) {
            <span class="phase active-phase">Ausschreibung beendet</span>
          }
        } @else {
          <p>Sie haben noch kein Angebot erstellt.</p>
        }
        @if (ausschreibung.ausschreibungsDokumente && ausschreibung.ausschreibungsDokumente.length) {
          <stzh-heading level="2">Dokumente zur Ausschreibung</stzh-heading>
          @if (ausschreibung.ausschreibungsDokumente && ausschreibung.ausschreibungsDokumente.length > 0) {
            <div class="mod_downloadlink"
              >
              @for (doc of ausschreibung.ausschreibungsDokumente; track doc) {
                <a [href]=generateAusschreibungsDokumenDocumentUrl(doc.id) class="downloadlink icon_document" target="_blank">
                  {{doc.name}}
                </a>
              }
            </div>
          } @else {
            <p>Keine Dokumente vorhanden.</p>
          }
        }
        @if (ausschreibung.presentDocuments && ausschreibung.presentDocuments.length) {
          <stzh-heading level="2">Ihre Angebotsdokumente</stzh-heading>
          @if (ausschreibung.presentDocuments && ausschreibung.presentDocuments.length > 0) {
            <div class="mod_downloadlink"
              >
              @for (doc of ausschreibung.presentDocuments; track doc) {
                <a [href]="generateAusschreibungDocumentUrl(doc)" class="downloadlink icon_document" target="_blank">
                  {{doc.filename}}
                </a>
              }
            </div>
          } @else {
            <p>Keine Dokumente vorhanden.</p>
          }
          @if (ausschreibung.angebot && ausschreibung.angebot.hash) {
            <div>
              Referenz-Nummer: {{ ausschreibung.angebot.hash }}
            </div>
          }
        }
      </stzh-cspace>
    </div>
    </div>
  </stzh-cspace>
}

